import { memo, useRef } from 'react'

import Popup from "../../popup"
import { Block, CRRender, Image, Inline } from '../../crRender'
import { useTranslation } from 'react-i18next'
import placeholderImg from '@/assets/images/Not_available.jpg'

const ImgPopup = ({ link, isHideText = false, refImg = null }) => {

  const imgRef = refImg || useRef()
  const { t } = useTranslation()

  return (
    <>
      <Block isRender={!!link} className='img-popup-container'>
        <CRRender isRender={!isHideText}>
          <span className='cta-click img' onClick={() => imgRef.current.click()}>{t("show-img-popup")}</span>
        </CRRender>
        <Popup needbtn={false} large={false} title={"show-img-popup"} name={`img-${Date.now()}`} modalID={imgRef}>
          <Image className={"img-lin-popup"} src={link} placeholder={placeholderImg} />
        </Popup>
      </Block>

      <Inline isRender={!link &&!isHideText}>{t("no-data")}</Inline>
    </>
  )
}

export default memo(ImgPopup)